module.exports = __webpack_public_path__ + "img/search.28ddcc85.png";